import React from 'react';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';

export const WIZARD_NUMBER_STATES = {
  DONE: 'DONE',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  INITIAL: 'INITIAL'
};
const WizardNumberWrapper = styled(Flex)`
  border-radius: 50%;
  position: relative;
  border: 1px solid transparent;
  ${({ state }) => {
    switch (state) {
      case WIZARD_NUMBER_STATES.ACTIVE:
        return `
          border: 1px solid ${getColor('dodgerBlue')};
          background-color: ${getColor('catskillWhite')};`;
      case WIZARD_NUMBER_STATES.DONE:
      case WIZARD_NUMBER_STATES.INITIAL:
        return `
          background-color: ${getColor('dodgerBlue')};
        `;
      case WIZARD_NUMBER_STATES.INACTIVE:
        return `
          background-color: ${getColor('botticelli')};
        `;
      default:
        return '';
    }
  }}
`;
const StyledIcon = styled(Icon)`
  position: absolute;
  left: 1.3rem;
  top: -0.3rem;
  background-color: white;
  border-radius: 50%;
`;
const WizardNumber = ({ state, number }) => (
  <WizardNumberWrapper
    data-testid='wizard-number'
    state={state}
    items='center'
    justify='center'
    width='2rem'
    height='2rem'
  >
    <Text
      weight='500'
      size='large'
      color={state === WIZARD_NUMBER_STATES.ACTIVE ? 'dodgerBlue' : 'white'}
    >
      {number}
    </Text>
    {state === WIZARD_NUMBER_STATES.DONE && (
      <StyledIcon
        data-testid='success-icon'
        name='SuccessOutline'
        color='malachiteB'
        size='x-small'
      />
    )}
  </WizardNumberWrapper>
);

export default WizardNumber;
